var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Clock",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-clock","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M125 .7C56.4.7.7 56.4.7 125S56.4 249.3 125 249.3 249.3 193.6 249.3 125 193.6.7 125 .7zm0 238.6C62 239.3 10.7 188 10.7 125S62 10.7 125 10.7 239.3 62 239.3 125 188 239.3 125 239.3z"/>
  <polygon points="87.1,48.8 78,53.2 120.9,139 190,139 190,129 127.2,129"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/clock.svg